import {supabase} from "../../supabase";
import {useState} from "react";
import {StorageError} from "@supabase/storage-js";


export const useImageUpload = (bucket: string, onUpload: (path: string) => void, basepath: string = "",) => {
    const [uploading, setUploading] = useState(false)
    const [error, setError] = useState<StorageError | undefined>(undefined)
    const uploadImage = async function uploadAvatar(file: File) {
        try {
            setUploading(true)
            const fileExt = file.name.split('.').pop();
            const path = `${new Date().getFullYear()}-${new Date().getMonth()}/${Date.now()}.${fileExt}`
            const {data, error: uploadError} = await supabase.storage
                .from(bucket)
                .upload(path, file, {
                    contentType: file.type ?? 'image/jpeg',
                })

            if (uploadError) {
                setError(uploadError)
                return
            }
            if (data) {
                onUpload(data.path)
            }
        } catch (error) {
            if (error instanceof Error) {
                setError(new StorageError(`${error}`))
            }
        } finally {
            setUploading(false)
        }
    }
    return {uploading, error, uploadImage};

}
